import React from 'react';
import { Modal, View, TouchableOpacity, Image } from 'react-native';
import closeIcon from 'src/assets/close.png';
import { styles } from './CenteredModal.styles';
import Typography from 'src/components/Text/Text';

interface CentralModalProps {
  visible?: boolean; // Default to true
  onClose?: (() => void) | null; // Optional
  children: React.ReactNode;
  title?: string;
}

const CentralModal: React.FC<CentralModalProps> = ({
  visible = true,
  onClose = null,
  children,
  title,
}) => {
  return (
    <Modal transparent visible={visible} animationType="fade" onRequestClose={onClose || undefined}>
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          {/* Render close button only if onClose is provided */}
          {onClose && (
            <TouchableOpacity style={styles.closeButton} onPress={onClose}>
              <Image source={closeIcon} style={styles.icon} />
            </TouchableOpacity>
          )}
          {title && (
            <Typography variant="h4" style={styles.title}>
              {title}
            </Typography>
          )}
          <View style={styles.content}>{children}</View>
        </View>
      </View>
    </Modal>
  );
};

export default CentralModal;
